export default {
    delivery: "Dostava",
    payment: "Plaćanje",
    approval: "Potvrda"
};
